import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getAssignedseatsBasedQuantities, getFixedQuantities } from './utils';

export const office = [
  {
    id: 1,
    name: 'spaceTypes.office.small',
    displayOrder: 1,
    spaceTypeId: spaceTypes.office.id,
    size: {
      [countries.US]: getSize(10.0, 10.0),
      [countries.UK]: getSize(10.0, 10.0),
      [countries.FR]: getSize(2.7, 3.7),
      [countries.EU]: getSize(2.0, 3.0),
      [countries.DE]: getSize(2.0, 3.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499745/insite/qa/spaces/gq1ro85j0xaacye1wqhs.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499745/insite/qa/spaces/gq1ro85j0xaacye1wqhs.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499745/insite/qa/spaces/gq1ro85j0xaacye1wqhs.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499745/insite/qa/spaces/gq1ro85j0xaacye1wqhs.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499745/insite/qa/spaces/gq1ro85j0xaacye1wqhs.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 2,
    name: 'spaceTypes.office.medium',
    displayOrder: 2,
    spaceTypeId: spaceTypes.office.id,
    size: {
      [countries.US]: getSize(12.0, 10.0),
      [countries.UK]: getSize(12.0, 10.0),
      [countries.FR]: getSize(2.7, 5.2),
      [countries.EU]: getSize(3.0, 4.0),
      [countries.DE]: getSize(3.0, 4.0),
    },
    quantity: {
      [countries.US]: getAssignedseatsBasedQuantities(0.15, 0.05, 0),
      [countries.UK]: getAssignedseatsBasedQuantities(0.15, 0.05, 0),
      [countries.FR]: getAssignedseatsBasedQuantities(0.15, 0.05, 0),
      [countries.EU]: getAssignedseatsBasedQuantities(0, 0.15, 0.05),
      [countries.DE]: getAssignedseatsBasedQuantities(0, 0.15, 0.05),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818101/insite/qa/spaces/qnwnlfgbp2f3ptzezh5k.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818101/insite/qa/spaces/qnwnlfgbp2f3ptzezh5k.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818101/insite/qa/spaces/qnwnlfgbp2f3ptzezh5k.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818101/insite/qa/spaces/qnwnlfgbp2f3ptzezh5k.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818101/insite/qa/spaces/qnwnlfgbp2f3ptzezh5k.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 3,
    name: 'spaceTypes.office.large',
    displayOrder: 3,
    spaceTypeId: spaceTypes.office.id,
    size: {
      [countries.US]: getSize(15.0, 15.0),
      [countries.UK]: getSize(15.0, 15.0),
      [countries.FR]: getSize(4.1, 5.2),
      [countries.EU]: getSize(4.0, 5.0),
      [countries.DE]: getSize(4.0, 5.0),
    },
    quantity: {
      [countries.US]: getAssignedseatsBasedQuantities(0.05, 0, 0),
      [countries.UK]: getAssignedseatsBasedQuantities(0.05, 0, 0),
      [countries.FR]: getAssignedseatsBasedQuantities(0.05, 0, 0),
      [countries.EU]: getAssignedseatsBasedQuantities(0, 0.05, 0),
      [countries.DE]: getAssignedseatsBasedQuantities(0, 0.05, 0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818102/insite/qa/spaces/ts19pbnefstvh4r4ucyp.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818102/insite/qa/spaces/ts19pbnefstvh4r4ucyp.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818102/insite/qa/spaces/ts19pbnefstvh4r4ucyp.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818102/insite/qa/spaces/ts19pbnefstvh4r4ucyp.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818102/insite/qa/spaces/ts19pbnefstvh4r4ucyp.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
